import { isAfter } from "date-fns";

import { parseDateAndTime } from "@/utils/datetime";

interface Appointment {
  status?: string | null;
  endDate: string;
  endTime: string;
}

export function isAppointmentFinished(
  appointment: Appointment | null | undefined
): boolean {
  const endDateIsPastCurrentDate = isAfter(
    new Date(),
    parseDateAndTime(
      appointment?.endDate ?? new Date(),
      appointment?.endTime ?? new Date()
    )
  );
  return (
    (appointment?.status == "upcoming" || appointment?.status == "finished") &&
    endDateIsPastCurrentDate
  );
}
